import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import apiClient from "./util/apiClient";

async function loadLanguages(): Promise<void> {
    try {
        const languageData = await apiClient("language/list", "GET");
        for (const key in languageData) {
            if (languageData[key]) {
                i18n.addResourceBundle(
                    key,
                    "translations",
                    languageData[key],
                    true,
                    true
                );
            }
        }

        const translatorData = await apiClient("translator/translate", "GET");
        for (const languageCode in translatorData) {
            if (translatorData[languageCode]) {
                i18n.addResourceBundle(
                    languageCode,
                    "translations",
                    translatorData[languageCode],
                    true,
                    true
                );
            }
        }
    } catch (error) {
        console.error("Failed to load translations:", error);
    }
}

const langList = [
    "zh-Hans",
    "ar",
    "bg",
    "cs",
    "da",
    "de",
    "el",
    "en",
    "es",
    "et",
    "fi",
    "fr",
    "hu",
    "id",
    "it",
    "ja",
    "ko",
    "lt",
    "lv",
    "nb",
    "nl",
    "pl",
    "pt-PT",
    "ro",
    "ru",
    "sk",
    "sl",
    "sv",
    "tr",
    "uk",
];

i18n.use(initReactI18next).init(
    {
        fallbackLng: langList,
        ns: ["translations"],
        lng: sessionStorage.getItem("language") || "en",
        resources: {},
        debug: false,
    },
    (err) => {
        if (err) {
            return console.log("something went wrong loading", err);
        }
    }
);

loadLanguages();

export default i18n;

